/**
 * Detail-route classifier (v4 #1377). Detail pages get reduced chrome:
 * the top bar shows only the Net Worth figure (V4_ADDENDUM convention 2;
 * renamed from Tangible by #2140, from Live Net Worth by #2206) on one 44px
 * row at every width, and
 * the bottom-nav pill keeps its position while the icon + label render idle
 * (convention 8). One definition shared by the AppBar and Navigation so the
 * two treatments can never disagree.
 *
 * @param {string} pathname  location.pathname
 * @returns {boolean}
 */
export const isDetailRoute = (pathname) =>
  /^\/(ledgers|budgets)\/[^/]+/.test(pathname || '');

/**
 * Nav-idle routes (#1427): pages whose bottom-nav icon + label render idle
 * (convention 8) WITHOUT the top bar dropping to Tangible-only. The admin
 * page keeps the full metric trio (kit TopBar has no detail flag) but sits
 * outside the three nav sections.
 *
 * @param {string} pathname  location.pathname
 * @returns {boolean}
 */
export const isNavIdleRoute = (pathname) =>
  isDetailRoute(pathname) || pathname === '/admin';
